import React, { useContext } from "react";
import { AuthContext } from "../../../../context/Auth/AuthContext";
import viewDocumentLink from "../../../../api/viewDocumentLink";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../../utils/toast";
import "../../../../styles/LinkPopup.css";
import { MdError } from "react-icons/md";
import pdfDetails from "../../../../api/pdfDetails";
import { ViewActionButton } from "../../../common/ActionIconButton";

/*** Component for viewing the document in pdf viewer ***/
const DocumentViewer = ({
  tableValues,
  changeDocumentViewerState,
  disabled = false,
  disabledReason,
}) => {
  const { token } = useContext(AuthContext);
  const documentID = tableValues.document_id;

  const documentData = async function () {
    try {
      const response = await pdfDetails(token, documentID, "documents");
      const data = await response.data;
      return data[0]?.pdflink;
    } catch (err) {
      console.error(err);
    }
  };
  const openLinkInNewTab = async () => {
    const downloadLinkFormResponse = await viewDocumentLink({
      token: token,
      docId: tableValues.document_id,
    });

    if (
      downloadLinkFormResponse?.code === 200 &&
      downloadLinkFormResponse?.data[0]?.pdflink
    ) {
      const link = downloadLinkFormResponse?.data[0].pdflink;
      const data = downloadLinkFormResponse?.data;

      changeDocumentViewerState(
        tableValues.document_id,
        tableValues.document_request_id,
        downloadLinkFormResponse?.data[0]?.document_status,
        link,
        data,
        tableValues.update_document_name
          ? tableValues.update_document_name
          : tableValues.document_name,
        tableValues.doc_category,
        tableValues.document_desc,
        tableValues.document_sub_category,
        tableValues.document_type,
        // The row itself (extra, last argument) - lets the viewer header show
        // the linked request name / added date like All Documents does.
        tableValues
      );
    } else {
      showError("Download URL does not Exist");
    }
  };

  return (
    <div className="single-link-popup-container">
      <ViewActionButton
        onClick={openLinkInNewTab}
        disabled={disabled}
        disabledReason={disabledReason}
      />
    </div>
  );
};

export default DocumentViewer;
